import React from 'react';
import PageContainer from "../../../../hoc/PageContainer";

const Hkdsa = () =>(
    <div>
        <PageContainer page={"hkdsa"}>
            <h1 className="AboutUsTitle">Rotary Club of Central - Year 2017 - 2019 : 3 years cooperation planning with Hong Kong Down Syndrome Association</h1>
            <div className="our-services-video-container">
                <iframe width="854" height="480" src="https://www.youtube.com/embed/HKCd6qRPcAY" frameBorder="0"
                        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen/>

            </div>

            <div className="AboutUsText">
                Since Mar 2017, Rotary Club of Central had strategically cooperated with Hong Kong Down Syndrome Association for 3 years services planning. Such programe was going to give a continuously support to the people with Down Syndrome and in order train them to be independence.
            </div>
        </PageContainer>
    </div>
);

export default Hkdsa;
